import {
  imprimirServicoAntigo,
  imprimirServicoNovo,
  buscarDadosImpressao,
} from '../utils';
import adapter from './adapter';
import layout from './layout';
import { imprimirRelatorioAberturaCaixa} from 'modulo-gerencial-erp-pacotes-impressora-termica'

async function imprimir(id, query = '', usar_nova_impressao = false) {
 /*  if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 5, query);
  }

  const dados = await buscarDadosImpressao(id, 5);

  const { comandos } = layout(adapter(dados));

  const response = await imprimirServicoNovo(id, 'nota-abertura', comandos);
  return response.data; */

   return await imprimirRelatorioAberturaCaixa({id, buscarDadosImpressao, chamarServicoImpressoraTermica: imprimirServicoNovo, query: ''})
}

export default imprimir;
